import type { api } from '@vrplatform/data';
import { parseAsString, useQueryStates } from '@vrplatform/query-params';
import { day } from '@vrplatform/utils';
import { useNavigate, useParams } from 'react-router';

export type GuestBalancesOccupancyStatus =
  api['/reports/guest-balances']['get']['parameters']['query']['occupancyStatus'];

export const DEFAULT_GUEST_BALANCES_OCCUPANCY_STATUS: GuestBalancesOccupancyStatus =
  'departed';

export const resolveGuestBalancesOccupancyStatus = (
  occupancyStatus: GuestBalancesOccupancyStatus | undefined
) => occupancyStatus || DEFAULT_GUEST_BALANCES_OCCUPANCY_STATUS;

export function useGuestBalancesTableFilter() {
  const [queryParams, setQueryParams] = useQueryStates({
    endDate: parseAsString,
    channels: parseAsString,
  });

  const { endDate, channels } = queryParams;
  const goto = useNavigate();
  const { occupancyStatus } = useParams<{
    occupancyStatus: GuestBalancesOccupancyStatus;
  }>();

  const setOccupancyStatus = (
    updatedOccupancyStatus: GuestBalancesOccupancyStatus
  ) => {
    const search = new URLSearchParams(window.location.search);
    goto(
      `/reports/guest-balances/${updatedOccupancyStatus}?${search.toString()}`
    );
  };

  return {
    filter: {
      occupancyStatus: resolveGuestBalancesOccupancyStatus(occupancyStatus),
      endDate:
        endDate && day(endDate).isValid()
          ? day(endDate).yyyymmdd()
          : day().yyyymmdd(),
      channels: channels?.split(',') ?? [],
    },
    setQueryParams,
    setOccupancyStatus,
  };
}
